import { generateId } from "@evergis/api";
import produce from "immer";
import { PrintInfo, PrintTaskInput, PrintType, TemplateModel } from "../../../interfaces/print";
import { TemplateFactory } from "../print/TemplateFactory";
import { getLegendPlacement } from "../../../ducks/print/getLegendPlacement";

const addStorageDescription = (printTask: PrintTaskInput) => {
  printTask.targetStorageDescription = {
    folderName: generateId(),
  };
};

const addTemplate = (template: TemplateModel) => (printTask: PrintTaskInput) => {
  printTask.templates.push(template);
};

export const createPrintTaskInput = async (printInfo: PrintInfo) => {
  const templateFactory = new TemplateFactory(printInfo);
  let printTaskInput: PrintTaskInput = { templates: [], targetStorageDescription: {} };

  printTaskInput = produce(printTaskInput, addStorageDescription);
  printTaskInput = produce(printTaskInput, addTemplate(await templateFactory.mapTemplate()));

  const isLegendSeparate = getLegendPlacement(printInfo.settings) === PrintType.MapAndLegend;

  if (isLegendSeparate) {
    printTaskInput = produce(printTaskInput, addTemplate(await templateFactory.legendTemplate()));
  }

  return printTaskInput;
};
